export const getPaypalValue = (value)=> {
    if (!Array.isArray(value.paymentMethods) || !value.paymentMethods.length) {
        return "";
    };
    return value.paymentMethods[0].email;

}